import { isBangladesh } from '../hooks/useGeoCascade'

// Choosing Bangladesh on the signup form puts +88 in front of the number, so
// the member goes on typing the familiar 01XXXXXXXXX after it. Choosing another
// country takes it away again. A number already carrying 88 / +88 is not
// doubled. Lives here rather than in the form so it can be unit-tested and so
// the form file keeps exporting only a component (react-refresh).
const BD_PREFIX = '+88'

export const phoneForCountry = (phone, country) => {
  const p = (phone || '').trim()
  if (isBangladesh(country)) return BD_PREFIX + p.replace(/^\+?88(?=0)/, '')
  return p.startsWith(BD_PREFIX) ? p.slice(BD_PREFIX.length) : p
}
